var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1975 26.1474H16.1318V18.6578H11.5228V26.1474H3.45703V14.0488C3.45703 13.7308 3.71456 13.4727 4.03316 13.4727C4.35175 13.4727 4.60928 13.7308 4.60928 14.0488V24.9951H10.3705V17.5055H17.284V24.9951H23.0453V14.6249C23.0453 14.3069 23.3028 14.0488 23.6214 14.0488C23.94 14.0488 24.1975 14.3069 24.1975 14.6249V26.1474Z",
    fill: "#5956E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.078 14.0482C26.9345 14.0482 26.7917 13.9952 26.6799 13.8886L13.8271 1.59471L0.974373 13.8886C0.744499 14.1081 0.379813 14.1006 0.159733 13.8708C-0.0603466 13.6409 -0.0517047 13.2762 0.177593 13.0561L13.8271 0L27.4761 13.0556C27.7054 13.2756 27.714 13.6403 27.494 13.8702C27.381 13.9883 27.2301 14.0482 27.078 14.0482Z",
    fill: "#5956E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4684 7.13434C22.1498 7.13434 21.8922 6.87624 21.8922 6.55822V3.10147H18.4355C18.1169 3.10147 17.8594 2.84336 17.8594 2.52534C17.8594 2.20732 18.1169 1.94922 18.4355 1.94922H23.0445V6.55822C23.0445 6.87624 22.787 7.13434 22.4684 7.13434Z",
    fill: "#E541ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5ec5aa4d280ab5fbcf5b03e2f19da16c.svg";
export { ForwardRef as ReactComponent };